<template>
  <div
    data-sidebar="footer"
    :class="cn('tw:flex tw:flex-col tw:gap-2 tw:p-2', props.class)"
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
